import React, { Fragment, useEffect, useState } from 'react';
import TopHeader from '../../../Components/TopHeader/TopHeader';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import Skeleton from 'react-loading-skeleton';
import { useDispatch } from 'react-redux';
import Constant from '../../../Utils/Constant';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import NoDataImg from '../../../Components/NoDataFound/NoDataFound';// Update path accordingly
import AxiosInstance from '../../../Config/AxiosInstance';
import APILIST from '../../../Config/ApiList';

const InfoBlock = ({ label, value }) => (
    <Box sx={{ mb: 1 }}>
        <Typography sx={{ fontSize: "15px", fontWeight: 300, color: "rgba(0, 0, 0, 0.7)", fontFamily: "Outfit" }}>
            {label}
        </Typography>
        <Typography sx={{ fontSize: "14px", fontWeight: 500, color: "rgba(8, 85, 127, 1)", textTransform: "capitalize", fontFamily: "Outfit" }}>
            {value || "Not available"}
        </Typography>
    </Box>
);

const JobReportViewDetails = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [reportedDetails, setReportedDetails] = useState([]);

    useEffect(() => {
        if (location?.state?.id) {
            getReportedDetails(location.state.id);
        }
    }, [location?.state?.id]);

    const getReportedDetails = async (id) => {
        try {
            setIsLoading(true);
            const result = await AxiosInstance.get(APILIST.GET_BY_ID_JOB_REPORTS,{
                params: { job_id: id }
            });
            if (result?.data?.s === 1) {
                setReportedDetails(result?.data?.r || []);
            } else {
                setReportedDetails([]);
            }
        } catch (error) {
            console.error("Error fetching user details", error);
        } finally {
            setIsLoading(false);
        }
    };

    const skeletonItems = Array.from({ length: 6 }).map((_, index) => (
        <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
            <Card sx={{ background: "rgba(230, 245, 247, 1)", position: "relative" }}>
                <CardContent>
                    <Skeleton height={100} width={100} borderRadius={50} />
                    {["Full Name", "Email", "Report Type", "Description", "Certification Status", "Account Status"].map((label, i) => (
                        <Box key={i} sx={{ mt: 2 }}>
                            <Typography sx={{ fontSize: "15px", fontWeight: "300", color: "rgba(0, 0, 0, 0.7)", fontFamily: "Outfit" }}>
                                {label}
                            </Typography>
                            <Skeleton height={20} />
                        </Box>
                    ))}
                </CardContent>
            </Card>
        </Grid>
    ));

    return (
        <Fragment>
            <TopHeader
                title={"Job Reported Details"}
                onClick={() => navigate(-1)}
                type="button"
                showButton={false}
            />

            <Box
                sx={{
                    padding: "100px 15px 40px 15px",
                    maxWidth: "100%",
                    margin: "0 auto",
                }}
            >
                <Grid container spacing={4}>
                    {isLoading ? (
                        skeletonItems
                    ) : reportedDetails?.length > 0 ? (
                        reportedDetails.map((elem, index) => (
                            <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                                <Card sx={{ background: "rgba(230, 245, 247, 1)", position: "relative", height: "100%" }}>
                                    <CardContent>
                                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                                            {elem?.profile_img ? (
                                                <img
                                                    src={`${Constant.BASE_URL}${elem?.profile_img}`}
                                                    alt="user_Profile"
                                                    style={{
                                                        width: "100px",
                                                        height: "100px",
                                                        objectFit: "cover",
                                                        borderRadius: "50%",
                                                        objectPosition: "top",
                                                    }}
                                                />
                                            ) : (
                                                <AccountCircleIcon sx={{ fontSize: "100px", color: "#ccc" }} />
                                            )}
                                        </Box>

                                        <InfoBlock label="Full Name" value={elem?.full_name} />
                                        <InfoBlock label="Email" value={elem?.email} />
                                        <InfoBlock label="Report Type" value="Reported User" />
                                        <InfoBlock label="Description" value={elem?.description} />
                                        <InfoBlock
                                            label="Certification Status"
                                            value={elem?.is_certified === 1 ? "Certified" : "Not Certified"}
                                        />
                                        <InfoBlock
                                            label="Account Status"
                                            value={elem?.status === 1 ? "Active" : "Inactive"}
                                        />
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))
                    ) : (
                        <Grid item xs={12}><NoDataImg /></Grid>
                    )}
                </Grid>
            </Box>
        </Fragment>
    );
};

export default JobReportViewDetails;
